var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{ref:"placeSearch",staticClass:"mb-2 placeSearch",attrs:{"outlined":"","hide-details":"","placeholder":"การเดินทางไปทำงาน/เรียน จากตรงนี้ใช้เวลากี่นาที"}})
}
var staticRenderFns = []

export { render, staticRenderFns }